export default "__VITE_ASSET__DxFRF$2W__"